__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-04-23-1776951062-stable-dev/";